import React from 'react'
import { Row, Col } from 'react-bootstrap'
import Link from 'next/link'

const FeatureItem = (props) => {
  const { t } = props

  const menu = [
    {
      img: 'img_4.webp',
      name: t('feature.name-1'),
      descrition: t('feature.feature-1'),
      link: '/dating'
    },
    {
      img: 'img_5.webp',
      name: t('feature.name-2'),
      descrition: t('feature.feature-2'),
      link: '/live'
    },
    {
      img: 'img_6.webp',
      name: t('feature.name-3'),
      descrition: t('feature.feature-3'),
      link: '/chatroulette'
    },
    {
      img: 'img_7.webp',
      name: t('feature.name-4'),
      descrition: t('feature.feature-4'),
      link: '/chatrandom'
    },
    {
      img: 'img_8.webp',
      name: t('feature.name-5'),
      descrition: t('feature.feature-5'),
      link: '/anonymous'
    },
    {
      img: 'img_9.webp',
      name: t('feature.name-6'),
      descrition: t('feature.feature-6'),
      link: '/omegle'
    }
  ]
  return (
    <>
      <Row>
        {menu.map((item, index) => (
          <Col xl={4} lg={4} md={6} sm={12} xs={12} key={index}>
            <div className='container-feature-flirt__menu-item' >
              {/* <Image
                loader={({ src }) => `https://flirtbees.com/images/${src}`}
                src={item.img}
                alt={item.name}
                className='container-feature-flirt__menu-item__image'
                width='300px'
                height='267px'
                quality={100}
                loading='eager'
              /> */}
              <amp-img src={`https://flirtbees.com/images/${item.img}`} alt={item.name}
                className='container-feature-flirt__menu-item__image'
                width="300" height="267" ></amp-img>
              <h4>
              <Link href={{ pathname: item.link, shallow: true }}>
                <a className='container-feature-flirt__menu-item__link' >{item.name}</a>
              </Link>
              </h4>
              <p className='container-feature-flirt__menu-item__description'>
                {item.descrition}
              </p>
            </div>
          </Col>
        ))}
      </Row>
    </>
  )
}

export default FeatureItem
